import { useParticipantIds, useScreenShare } from '@daily-co/daily-react-hooks';
import { useEffect } from 'react';

import { usePinnedId } from '../../contexts/UIState';
import { ScreenshareButton } from './ScreenshareButton';
import { Unpin } from './Unpin';
import { ViewSwitch } from './ViewSwitch';

export const TopbarAction: React.FC = () => {
  const participantIds = useParticipantIds();
  const { screens } = useScreenShare();
  const [pinnedId, setPinnedId] = usePinnedId();

  const { stopScreenShare } = useScreenShare();

  useEffect(() => {
    if (!pinnedId) return;
    const pinned =
      participantIds.some((id) => id === pinnedId) ||
      screens.some((s) => s.screenId === pinnedId);
    if (!pinned) {
      // pinned tile is not present anymore
      setPinnedId(null);
    }
  }, [participantIds, pinnedId, screens, setPinnedId]);

  if (pinnedId) {
    return <Unpin />;
  }

  if (screens.length) {
    return <ScreenshareButton onClick={stopScreenShare} />;
  }

  return <ViewSwitch />;
};
